"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useElementActivationAction = void 0;
var react_1 = __importDefault(require("react"));
var element_popup_service_1 = require("./services/element-popup.service");
var canRoleToggleElement = function (role) {
    return role === 'admin' || role === 'group-owner' || role === 'owner';
};
exports.useElementActivationAction = function (_a) {
    var elementId = _a.elementId, role = _a.role;
    var canToggleActive = canRoleToggleElement(role);
    var _b = react_1.default.useState(true), isElementActive = _b[0], setIsElementActive = _b[1];
    var _c = react_1.default.useState(false), isTogglingElementState = _c[0], setIsTogglingElementState = _c[1];
    var _d = react_1.default.useState(null), toggleError = _d[0], setToggleError = _d[1];
    var handleToggleElementActive = react_1.default.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var ok, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!elementId || !canToggleActive || isTogglingElementState) {
                        return [2 /*return*/];
                    }
                    setIsTogglingElementState(true);
                    setToggleError(null);
                    if (!isElementActive) return [3 /*break*/, 2];
                    return [4 /*yield*/, element_popup_service_1.softDeleteElement(elementId)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, element_popup_service_1.restoreElement(elementId)];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    ok = _a;
                    if (!ok) {
                        setToggleError('Could not update element state. Try again.');
                        setIsTogglingElementState(false);
                        return [2 /*return*/];
                    }
                    setIsElementActive(function (current) { return !current; });
                    setIsTogglingElementState(false);
                    return [2 /*return*/];
            }
        });
    }); }, [canToggleActive, elementId, isElementActive, isTogglingElementState]);
    var activationAction = canToggleActive && elementId
        ? {
            key: 'toggle-active',
            label: isTogglingElementState
                ? isElementActive
                    ? 'Deactivating...'
                    : 'Activating...'
                : isElementActive
                    ? 'Deactivate'
                    : 'Activate',
            onClick: function () {
                void handleToggleElementActive();
            },
        }
        : undefined;
    return {
        activationAction: activationAction,
        toggleError: toggleError,
    };
};
